const routes = [
  {
    path: "login",
    name: "login",
    meta: { auth: false },
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/view/authentication/SignIn.vue"
      ),
  },
  {
    path: "/auth/linkedin/callback",
    name: "loginLinkedin",
    meta: { auth: false },
    component: () =>
      import(
        /* webpackChunkName: "login with linkedin" */ "../view/authentication/SignInLinkedin"
      ),
  },

  {
    path: "register",
    name: "register",
    meta: { auth: false },
    component: () =>
      import(
        /* webpackChunkName: "register" */ "@/view/authentication/Signup.vue"
      ),
    children: [
      {
        path: "signupCompany",
        name: "signupCompany",
        meta: { auth: false },
        component: () =>
          import(
            /* webpackChunkName: "forgotPassword" */ "@/view/authentication/SignUpCompany.vue"
          ),
      },
      {
        path: "signupCandidate",
        name: "signupCandidate",
        meta: { auth: false },
        component: () =>
          import(
            /* webpackChunkName: "forgotPassword" */ "@/view/authentication/SignUpCandidate.vue"
          ),
      },
    ],
  },

  {
    path: "forgotPassword",
    name: "forgotPassword",
    meta: { auth: false },
    component: () =>
      import(
        /* webpackChunkName: "forgotPassword" */ "@/view/authentication/ForgotPassword.vue"
      ),
  },

  {
    path: "reset-password",
    name: "resetPassword",
    meta: { auth: false },
    component: () =>
      import(
        /* webpackChunkName: "forgotPassword" */ "@/view/authentication/ResetPassword.vue"
      ),
  },
];
export default routes;
